// src/routes/index.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import HomeRoutes from "./HomeRoutes";
import AdminRoutes from "./AdminRoutes";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Admin console — sits outside the marketing layout */}
      <Route path="/admin/*" element={<AdminRoutes />} />

      {/* Home routes - catch-all for the main site */}
      <Route path="/*" element={<HomeRoutes />} />
    </Routes>
  );
};

export default AppRoutes;
